// const baseUrl = "http://localhost:3006/api/";
const baseUrl = "https://renewed-melamie-kevinpatel-83b066dc.koyeb.app/api/";

export const loginApi = async (formData) => {
  const data = await fetch(`${baseUrl}admin/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const getAllCourse = async (formData) => {
  const data = await fetch(
    `${baseUrl}course/adminlist?page=${formData?.offset}&size=${formData?.limit}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const _data = await data.json();
  return _data;
};

export const storeCourse = async (formData) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}course/store`, {
    method: "POST",
    headers: {
      Authorization: `Token ${token}`,
      // 'Content-Type': 'multipart/form-data'
    },
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const deleteCourse = async (formData) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}course/delete/${formData?.id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const updateCourse = async (formData, id) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}course/update/${id}`, {
    method: "PUT",
    headers: {
      Authorization: `Token ${token}`,
      // 'Content-Type': 'multipart/form-data'
    },
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const getAllContact = async (formData) => {
  const data = await fetch(
    `${baseUrl}contact/list?page=${formData?.offset}&size=${formData?.limit}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const _data = await data.json();
  return _data;
};
export const exportContact = async (formData) => {
  const data = await fetch(`${baseUrl}contact/list`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const deleteContact = async (formData) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}contact/delete/${formData?.id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};
export const updateCommentContact = async (formData) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}contact/updateCommnet/${formData?.id}`, {
    method: "PUT",
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};
export const updateCommentUser = async (formData) => {
  const token = localStorage.getItem("token");
  const data = await fetch(
    `${baseUrl}registerUser/updateComment/${formData?.id}`,
    {
      method: "PUT",
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    }
  );
  const _data = await data.json();
  return _data;
};

export const getAllUser = async (formData) => {
  const data = await fetch(
    `${baseUrl}registerUser/list?page=${formData?.offset}&size=${formData?.limit}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const _data = await data.json();
  return _data;
};
export const exportuser = async (formData) => {
  const data = await fetch(`${baseUrl}registerUser/list`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const deleteUser = async (formData) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}registerUser/delete/${formData?.id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const getAllTestimonials = async (formData) => {
  const data = await fetch(
    `${baseUrl}testimonials/adminlist?page=${formData?.offset}&size=${formData?.limit}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const _data = await data.json();
  return _data;
};

export const deleteTestimonials = async (formData) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}testimonials/delete/${formData?.id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const storeTestimonials = async (formData) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}testimonials/store`, {
    method: "POST",
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const updateTestimonials = async (formData, id) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}testimonials/update/${id}`, {
    method: "PUT",
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const getAllGallery = async (formData) => {
  const data = await fetch(
    `${baseUrl}gallery/list?page=${formData?.offset}&size=${formData?.limit}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const _data = await data.json();
  return _data;
};

export const deleteGallery = async (formData) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}gallery/delete/${formData?.id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const storeGallery = async (formData) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}gallery/store`, {
    method: "POST",
    headers: {
      Authorization: `Token ${token}`,
    },
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const updateGallery = async (formData, id) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}gallery/update/${id}`, {
    method: "PUT",
    headers: {
      Authorization: `Token ${token}`,
    },
    body: formData,
  });
  const _data = await data.json();
  return _data;
};
export const updateProfile = async (formData) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}admin/updateProfile/${formData?.id}`, {
    method: "PUT",
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const getAllUseCase = async (formData) => {
  const data = await fetch(
    `${baseUrl}useCase/list?page=${formData?.offset}&size=${formData?.limit}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const _data = await data.json();
  return _data;
};
export const exportUseCase = async (formData) => {
  const data = await fetch(`${baseUrl}useCase/list`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};
export const getProfileDetails = async (formData) => {
  const data = await fetch(
    `${baseUrl}admin/getProile?page=${formData?.offset}&size=${formData?.limit}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const _data = await data.json();
  return _data;
};

export const deleteUseCase = async (formData) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}useCase/delete/${formData?.id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const getAllBrand = async (formData) => {
  const data = await fetch(
    `${baseUrl}brand/list?page=${formData?.offset}&size=${formData?.limit}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const _data = await data.json();
  return _data;
};

export const deleteBrand = async (formData) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}brand/delete/${formData?.id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const storeBrand = async (formData) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}brand/store`, {
    method: "POST",
    headers: {
      Authorization: `Token ${token}`,
    },
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const updateBrand = async (formData, id) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}brand/update/${id}`, {
    method: "PUT",
    headers: {
      Authorization: `Token ${token}`,
    },
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const duplicateCourse = async (formData) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}course/duplicate/${formData?.id}`, {
    method: "GET",
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const getAllEvent = async (formData) => {
  const data = await fetch(
    `${baseUrl}event/list?page=${formData?.offset}&size=${formData?.limit}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const _data = await data.json();
  return _data;
};

export const deleteEvent = async (formData) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}event/delete/${formData?.id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const storeEvent = async (formData) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}event/store`, {
    method: "POST",
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const updateEvent = async (formData, id) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}event/update/${id}`, {
    method: "PUT",
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};
